export const saleEndDate = "11 Nov 2023 22:00:00 GMT";
export const shopURL = "https://bluescandies.ro/";
export const productsURL =
  "https://bfbluescandies.blob.core.windows.net/products/products.json";
